import { render, staticRenderFns } from "./WSubtitle.vue?vue&type=template&id=90f128b8&scoped=true&"
import script from "./wSubtitle.ts?vue&type=script&lang=ts&"
export * from "./wSubtitle.ts?vue&type=script&lang=ts&"
import style0 from "./WSubtitle.vue?vue&type=style&index=0&id=90f128b8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90f128b8",
  null
  
)

export default component.exports